//* SETTINGS */
export const CHANGE_LOCALE = "CHANGE_LOCALE";

//* MENU */
export const MENU_SET_CLASSNAMES = "MENU_SET_CLASSNAMES";
export const MENU_CONTAINER_ADD_CLASSNAME = "MENU_CONTAINER_ADD_CLASSNAME";
export const MENU_CLICK_MOBILE_MENU = "MENU_CLICK_MOBILE_MENU";
export const MENU_CHANGE_DEFAULT_CLASSES = "MENU_CHANGE_DEFAULT_CLASSES";
export const MENU_CHANGE_HAS_SUB_ITEM_STATUS = "MENU_CHANGE_HAS_SUB_ITEM_STATUS";

//* AUTHENTICATION */
export const LOGIN_USER = "LOGIN_USER";
export const LOGIN_USER_SUCCESS = "LOGIN_USER_SUCCESS";
export const LOGIN_USER_ERROR = "LOGIN_USER_ERROR";
export const SIGNUP_USER = "SIGNUP_USER";
export const SIGNUP_USER_SUCCESS = "SIGNUP_USER_SUCCESS";
export const SIGNUP_USER_ERROR = "SIGNUP_USER_ERROR";
export const CHECK_USER = "CHECK_USER";
export const CHECK_USER_SUCCESS = "CHECK_USER_SUCCESS";
export const CHECK_USER_ERROR = "CHECK_USER_ERROR";
export const SIGNIN_USER = "SIGNIN_USER";
export const SIGNIN_USER_SUCCESS = "SIGNIN_USER_SUCCESS";
export const SIGNIN_USER_ERROR = "SIGNIN_USER_ERROR";
export const REGISTER_USER = "REGISTER_USER";
export const REGISTER_USER_SUCCESS = "REGISTER_USER_SUCCESS";
export const REGISTER_USER_ERROR = "REGISTER_USER_ERROR";
export const LOGOUT_USER = "LOGOUT_USER";
export const FORGOT_PASSWORD = "FORGOT_PASSWORD";
export const FORGOT_PASSWORD_SUCCESS = "FORGOT_PASSWORD_SUCCESS";
export const FORGOT_PASSWORD_ERROR = "FORGOT_PASSWORD_ERROR";
export const RESET_PASSWORD = "RESET_PASSWORD";
export const RESET_PASSWORD_SUCCESS = "RESET_PASSWORD_SUCCESS";
export const RESET_PASSWORD_ERROR = "RESET_PASSWORD_ERROR";

//* USER */
export const USER_GET_DATA = "USER_GET_DATA";
export const USER_GET_DATA_SUCCESS = "USER_GET_DATA_SUCCESS";
export const USER_GET_DATA_ERROR = "USER_GET_DATA_ERROR";

export const USER_EDIT_ITEM = "USER_EDIT_ITEM";
export const USER_EDIT_ITEM_SUCCESS = "USER_EDIT_ITEM_SUCCESS";
export const USER_EDIT_ITEM_ERROR = "USER_EDIT_ITEM_ERROR";

export const USER_AVATAR_EDIT_ITEM = "USER_AVATAR_EDIT_ITEM";
export const USER_AVATAR_EDIT_ITEM_SUCCESS = "USER_AVATAR_EDIT_ITEM_SUCCESS";
export const USER_AVATAR_EDIT_ITEM_ERROR = "USER_AVATAR_EDIT_ITEM_ERROR";

export const USER_GET_AVATAR = "USER_GET_AVATAR";
export const USER_GET_AVATAR_SUCCESS = "USER_GET_AVATAR_SUCCESS";
export const USER_GET_AVATAR_ERROR = "USER_GET_AVATAR_ERROR";

export const USER_REMOVE_ITEM = "USER_REMOVE_ITEM";
export const USER_REMOVE_ITEM_SUCCESS = "USER_REMOVE_ITEM_SUCCESS";
export const USER_REMOVE_ITEM_ERROR = "USER_REMOVE_ITEM_ERROR";

export const USER_VALIDATE_ITEM = "USER_VALIDATE_ITEM";
export const USER_VALIDATE_ITEM_SUCCESS = "USER_VALIDATE_ITEM_SUCCESS";
export const USER_VALIDATE_ITEM_ERROR = "USER_VALIDATE_ITEM_ERROR";

export const USER_ADMIN_EDIT_ITEM = "USER_ADMIN_EDIT_ITEM";
export const USER_ADMIN_EDIT_ITEM_SUCCESS = "USER_ADMIN_EDIT_ITEM_SUCCESS";
export const USER_ADMIN_EDIT_ITEM_ERROR = "USER_ADMIN_EDIT_ITEM_ERROR";

export const USER_CLEAR_DATA = "USER_CLEAR_DATA";

//* DOCTORS */
export const DOCTORS_GET_LIST = "DOCTORS_GET_LIST";
export const DOCTORS_GET_LIST_ERROR = "DOCTORS_GET_LIST_ERROR";
export const DOCTORS_GET_LIST_SUCCESS = "DOCTORS_GET_LIST_SUCCESS";

export const DOCTOR_GET_DATA = "DOCTOR_GET_DATA";
export const DOCTOR_GET_DATA_SUCCESS = "DOCTOR_GET_DATA_SUCCESS";
export const DOCTOR_GET_DATA_ERROR = "DOCTOR_GET_DATA_ERROR";

export const DOCTOR_GET_AVATAR = "DOCTOR_GET_AVATAR";
export const DOCTOR_GET_AVATAR_SUCCESS = "DOCTOR_GET_AVATAR_SUCCESS";
export const DOCTOR_GET_AVATAR_ERROR = "DOCTOR_GET_AVATAR_ERROR";

export const DOCTOR_ADD_ITEM = "DOCTOR_ADD_ITEM";
export const DOCTOR_ADD_ITEM_SUCCESS = "DOCTOR_ADD_ITEM_SUCCESS";
export const DOCTOR_ADD_ITEM_ERROR = " DOCTOR_ADD_ITEM_ERROR";

export const DOCTOR_CLEAR_DATA = "DOCTOR_CLEAR_DATA";

//* PATIENTS */
export const PATIENTS_BYUSER_GET_LIST = "PATIENTS_BYUSER_GET_LIST";
export const PATIENTS_BYUSER_GET_LIST_SUCCESS = "PATIENTS_BYUSER_GET_LIST_SUCCESS";
export const PATIENTS_BYUSER_GET_LIST_ERROR = "PATIENTS_BYUSER_GET_LIST_ERROR";

export const PATIENTS_BYDOCTOR_GET_LIST = "PATIENTS_BYDOCTOR_GET_LIST";
export const PATIENTS_BYDOCTOR_GET_LIST_SUCCESS = "PATIENTS_BYDOCTOR_GET_LIST_SUCCESS";
export const PATIENTS_BYDOCTOR_GET_LIST_ERROR = "PATIENTS_BYDOCTOR_GET_LIST_ERROR";

export const PATIENT_GET_INFO = "PATIENT_GET_INFO";
export const PATIENT_GET_INFO_SUCCESS = "PATIENT_GET_INFO_SUCCESS";
export const PATIENT_GET_INFO_ERROR = "PATIENT_GET_INFO_ERROR";

export const PATIENT_ADD_ITEM = "PATIENT_ADD_ITEM";
export const PATIENT_ADD_ITEM_SUCCESS = "PATIENT_ADD_ITEM_SUCCESS";
export const PATIENT_ADD_ITEM_ERROR = " PATIENT_ADD_ITEM_ERROR";

export const PATIENTS_ADD_BULK_ITEMS = "PATIENTS_ADD_BULK_ITEMS";

export const PATIENT_EDIT_ITEM = "PATIENT_EDIT_ITEM";
export const PATIENT_EDIT_ITEM_SUCCESS = "PATIENT_EDIT_ITEM_SUCCESS";
export const PATIENT_EDIT_ITEM_ERROR = " PATIENT_EDIT_ITEM_ERROR";

export const PATIENT_REMOVE_ITEM = "PATIENT_REMOVE_ITEM";
export const PATIENT_REMOVE_ITEM_SUCCESS = "PATIENT_REMOVE_ITEM_SUCCESS";
export const PATIENT_REMOVE_ITEM_ERROR = "PATIENT_REMOVE_ITEM_ERROR";

export const PATIENTS_CLEAR_DATA = "PATIENTS_CLEAR_DATA";
export const PATIENT_CLEAR_DATA = "PATIENT_CLEAR_DATA";
export const PATIENT_CLEAR_MESSAGES = "PATIENT_CLEAR_MESSAGES";

//* KITS PER PATIENT */
export const KITS_BYPATIENT_GET_LIST = "KITS_BYPATIENT_GET_LIST";
export const KITS_BYPATIENT_GET_LIST_SUCCESS = "KITS_BYPATIENT_GET_LIST_SUCCESS";
export const KITS_BYPATIENT_GET_LIST_ERROR = "KITS_BYPATIENT_GET_LIST_ERROR";

export const KIT_GET_INFO = "KIT_GET_INFO";
export const KIT_GET_INFO_SUCCESS = "KIT_GET_INFO_SUCCESS";
export const KIT_GET_INFO_ERROR = "KIT_GET_INFO_ERROR";

export const KIT_ADD_ITEM = "KIT_ADD_ITEM";
export const KIT_ADD_ITEM_SUCCESS = "KIT_ADD_ITEM_SUCCESS";
export const KIT_ADD_ITEM_ERROR = "KIT_ADD_ITEM_ERROR";

export const KIT_EDIT_ITEM = "KIT_EDIT_ITEM";
export const KIT_EDIT_ITEM_SUCCESS = "KIT_EDIT_ITEM_SUCCESS";
export const KIT_EDIT_ITEM_ERROR = "KIT_EDIT_ITEM_ERROR";

export const KIT_UNLOCK_PLUGIN_ITEM = "KIT_UNLOCK_PLUGIN_ITEM";
export const KIT_UNLOCK_PLUGIN_ITEM_SUCCESS = "KIT_UNLOCK_PLUGIN_ITEM_SUCCESS";
export const KIT_UNLOCK_PLUGIN_ITEM_ERROR = "KIT_UNLOCK_PLUGIN_ITEM_ERROR";

export const KIT_ACTIVATE_ITEM = "KIT_ACTIVATE_ITEM";
export const KIT_ACTIVATE_ITEM_SUCCESS = "KIT_ACTIVATE_ITEM_SUCCESS";
export const KIT_ACTIVATE_ITEM_ERROR = "KIT_ACTIVATE_ITEM_ERROR";

export const KIT_GET_RESULTS = "KIT_GET_RESULTS";
export const KIT_GET_RESULTS_SUCCESS = "KIT_GET_RESULTS_SUCCESS";
export const KIT_GET_RESULTS_ERROR = "KIT_GET_RESULTS_ERROR";

export const KIT_GET_RESULTS_BEHAVIOUR = "KIT_GET_RESULTS_BEHAVIOUR";
export const KIT_GET_RESULTS_BEHAVIOUR_SUCCESS = "KIT_GET_RESULTS_BEHAVIOUR_SUCCESS";
export const KIT_GET_RESULTS_BEHAVIOUR_ERROR = "KIT_GET_RESULTS_BEHAVIOUR_ERROR";

export const KIT_GET_RESULTS_BIOMARKERS = "KIT_GET_RESULTS_BIOMARKERS";
export const KIT_GET_RESULTS_BIOMARKERS_SUCCESS = "KIT_GET_RESULTS_BIOMARKERS_SUCCESS";
export const KIT_GET_RESULTS_BIOMARKERS_ERROR = "KIT_GET_RESULTS_BIOMARKERS_ERROR";

export const KITS_GET_RESULTS_TIMECOURSE = "KITS_GET_RESULTS_TIMECOURSE";
export const KITS_GET_RESULTS_TIMECOURSE_SUCCESS = "KITS_GET_RESULTS_TIMECOURSE_SUCCESS";
export const KITS_GET_RESULTS_TIMECOURSE_ERROR = "KITS_GET_RESULTS_TIMECOURSE_ERROR";

export const KIT_REMOVE_ITEM = "KIT_REMOVE_ITEM";
export const KIT_REMOVE_ITEM_SUCCESS = "KIT_REMOVE_ITEM_SUCCESS";
export const KIT_REMOVE_ITEM_ERROR = "KIT_REMOVE_ITEM_ERROR";

export const KIT_GET_UPLOADED_DATA = "KIT_GET_UPLOADED_DATA";
export const KIT_GET_UPLOADED_DATA_SUCCESS = "KIT_GET_UPLOADED_DATA_SUCCESS";
export const KIT_GET_UPLOADED_DATA_ERROR = "KIT_GET_UPLOADED_DATA_ERROR";

export const KIT_REMOVE_UPLOADED_DATA = "KIT_REMOVE_UPLOADED_DATA";
export const KIT_REMOVE_UPLOADED_DATA_SUCCESS = "KIT_REMOVE_UPLOADED_DATA_SUCCESS";
export const KIT_REMOVE_UPLOADED_DATA_ERROR = "KIT_REMOVE_UPLOADED_DATA_ERROR";

export const KIT_TAKEACTION_EDIT_ITEM = "KIT_TAKEACTION_EDIT_ITEM";
export const KIT_TAKEACTION_EDIT_ITEM_SUCCESS = "KIT_TAKEACTION_EDIT_ITEM_SUCCESS";
export const KIT_TAKEACTION_EDIT_ITEM_ERROR = "KIT_TAKEACTION_EDIT_ITEM_ERROR";

export const KIT_TAKEACTION_REMOVE_ITEM = "KIT_TAKEACTION_REMOVE_ITEM";
export const KIT_TAKEACTION_REMOVE_ITEM_SUCCESS = "KIT_TAKEACTION_REMOVE_ITEM_SUCCESS";
export const KIT_TAKEACTION_REMOVE_ITEM_ERROR = "KIT_TAKEACTION_REMOVE_ITEM_ERROR";

export const KIT_RESULTS_COMMENTS_EDIT_ITEM = "KIT_RESULTS_COMMENTS_EDIT_ITEM";
export const KIT_RESULTS_COMMENTS_EDIT_ITEM_SUCCESS = "KIT_RESULTS_COMMENTS_EDIT_ITEM_SUCCESS";
export const KIT_RESULTS_COMMENTS_EDIT_ITEM_ERROR = "KIT_RESULTS_COMMENTS_EDIT_ITEM_ERROR";

export const KITS_BYPATIENT_LIST_CLEAR_DATA = "KITS_BYPATIENT_LIST_CLEAR_DATA";
export const KITS_RESULTS_CLEAR_DATA = "KITS_RESULTS_CLEAR_DATA";
export const KIT_CLEAR_DATA = "KIT_CLEAR_DATA";
export const KIT_CLEAR_MESSAGES = "KIT_CLEAR_MESSAGES";
export const KITS_RESULTS_TIMECOURSE_CLEAR_DATA = "KITS_RESULTS_TIMECOURSE_CLEAR_DATA";

//* KITS PER USER */
export const KITS_USER_GET_LIST = "KITS_USER_GET_LIST";
export const KITS_USER_GET_LIST_SUCCESS = "KITS_USER_GET_LIST_SUCCESS";
export const KITS_USER_GET_LIST_ERROR = "KITS_USER_GET_LIST_ERROR";

//* KITS PER DOCTOR */
export const KITS_BYDOCTOR_GET_LIST = "KITS_BYDOCTOR_GET_LIST";
export const KITS_BYDOCTOR_GET_LIST_SUCCESS = "KITS_BYDOCTOR_GET_LIST_SUCCESS";
export const KITS_BYDOCTOR_GET_LIST_ERROR = "KITS_BYDOCTOR_GET_LIST_ERROR";

//* KIT REPORT LOGO  */
export const KIT_REPORT_GET_LOGO = "KIT_REPORT_GET_LOGO";
export const KIT_REPORT_GET_LOGO_SUCCESS = "KIT_REPORT_GET_LOGO_SUCCESS";
export const KIT_REPORT_GET_LOGO_ERROR = "KIT_REPORT_GET_LOGO_ERROR";

export const KIT_REPORT_EDIT_LOGO = "KIT_REPORT_EDIT_LOGO";
export const KIT_REPORT_EDIT_LOGO_SUCCESS = "KIT_REPORT_EDIT_LOGO_SUCCESS";
export const KIT_REPORT_EDIT_LOGO_ERROR = "KIT_REPORT_EDIT_LOGO_ERROR";

//* HOLDED */
export const HOLDED_GET_CONTACTS_LIST = "HOLDED_CONTACTS_LIST";
export const HOLDED_GET_CONTACTS_LIST_SUCCESS = "HOLDED_GET_CONTACTS_LIST_SUCCESS";
export const HOLDED_GET_CONTACTS_LIST_ERROR = " HOLDED_GET_CONTACTS_LIST_ERROR";

export const HOLDED_GET_CONTACT_INFO = "HOLDED_GET_CONTACT_INFO";
export const HOLDED_GET_CONTACT_INFO_SUCCESS = "HOLDED_GET_CONTACT_INFO_SUCCESS";
export const HOLDED_GET_CONTACT_INFO_ERROR = "HOLDED_GET_CONTACT_INFO_ERROR";

export const HOLDED_ADD_CONTACT_INFO = "HOLDED_ADD_CONTACT_INFO";
export const HOLDED_ADD_CONTACT_INFO_SUCCESS = "HOLDED_ADD_CONTACT_INFO_SUCCESS";
export const HOLDED_ADD_CONTACT_INFO_ERROR = "HOLDED_ADD_CONTACT_INFO_ERROR";

export const HOLDED_UPDATE_CONTACT_INFO = "HOLDED_UPDATE_CONTACT_INFO";
export const HOLDED_UPDATE_CONTACT_INFO_SUCCESS = "HOLDED_UPDATE_CONTACT_INFO_SUCCESS";
export const HOLDED_UPDATE_CONTACT_INFO_ERROR = "HOLDED_UPDATE_CONTACT_INFO_ERROR";

export const HOLDED_ADD_DOCUMENT_ITEM = "HOLDED_ADD_DOCUMENT_ITEM";
export const HOLDED_ADD_DOCUMENT_ITEM_SUCCESS = "HOLDED_ADD_DOCUMENT_ITEM_SUCCESS";
export const HOLDED_ADD_DOCUMENT_ITEM_ERROR = "HOLDED_ADD_DOCUMENT_ITEM_ERROR";

export const HOLDED_CLEAR_DATA = "HOLDED_CLEAR_DATA";

//* STRIPE */

export const STRIPE_GET_CONTACT_INFO = "STRIPE_GET_CONTACT_INFO";
export const STRIPE_GET_CONTACT_INFO_SUCCESS = "STRIPE_GET_CONTACT_INFO_SUCCESS";
export const STRIPE_GET_CONTACT_INFO_ERROR = "STRIPE_GET_CONTACT_INFO_ERROR";

export const STRIPE_CLEAR_DATA = "STRIPE_CLEAR_DATA";

export * from "./settings/actions";
export * from "./menu/actions";
export * from "./auth/actions";
export * from "./user/actions";
export * from "./doctors/actions";
export * from "./patients/actions";
export * from "./kits/actions";
export * from "./holded/actions";
export * from "./stripe/actions";
